var map = {
	"./Collections-light.svg": "ac54",
	"./Customization-light.svg": "1415",
	"./Followings-light.svg": "87d4",
	"./Inquiry record-light.svg": "1696",
	"./My Demands-light.svg": "eafd",
	"./Notifications-light.svg": "3161",
	"./Password-light.svg": "4787",
	"./Profile-light.svg": "85fb",
	"./Reservations-light.svg": "eb17",
	"./Topics-light.svg": "7992"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2928";